import React, {useEffect, useState} from 'react';

export const TransitionWrapper = ({children}) => {

  const [opacity, setOpacity] = useState('opacity-0');

  useEffect(() => {
    setOpacity('opacity-100');
  }, [])

  return (
    <div className={`transition-wrapper ${opacity}`}>
      {children}
    </div>
  )
}